import { takeLatest, put } from "redux-saga/effects";
import * as API from "../api/api";

import {
  FETCH_AUTH,
  FETCH_AUTH_SUCCESS,
  FETCH_AUTH_FAIL,
  FETCH_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAIL,
  MsgAllowModel,
  MsgRejectModel,
} from "../config/constant";
import { store } from "../index";

function* getAuth(action) {
  try {
    yield put({
      type: FETCH_AUTH_SUCCESS,
      isAuth: action.isAuth,
      authType: action.authType,
    });
  } catch (error) {
    yield put({ type: FETCH_AUTH_FAIL });
  }
}
export function* watchAuth() {
  yield takeLatest(FETCH_AUTH, getAuth);
}

export const CANCEL_MODEL = 0;
export const DENY_MODEL = 1;
export const APPROVE_MODEL = 2;
export const BLOCK_USER = 3;
export const UNBLOCK_USER = 4;
export const SET_TEST_ACCOUNT = 5;
export const UNSET_TEST_ACCOUNT = 6;
export const UPDATE_RAKUTEN_TRACKING_ID = 7;

function* getUsers(action) {
  try {
    var data = [];
    const { user, users, kind } = action;

    if (user) {
      data = [...users];

      let notification = {
        receiverUid: user.uid,
        timestamp: new Date().getTime(),
      };

      switch (kind) {
        case CANCEL_MODEL:
          yield API.reset_user(user.uid, "modelTimestamp");
          yield API.update_user_field(user.uid, "approve", user.approve);
          break;
        case DENY_MODEL:
          notification = {
            ...notification,
            ...MsgRejectModel(user.name),
          };
          yield API.create_notification(notification);
          yield API.update_user_field(
            user.uid,
            "modelTimestamp",
            new Date().getTime()
          );
          yield API.update_user_field(user.uid, "approve", user.approve);
          break;
        case APPROVE_MODEL:
          notification = {
            ...notification,
            ...MsgAllowModel(user.name),
          };
          yield API.create_notification(notification);
          yield API.update_user_field(
            user.uid,
            "modelTimestamp",
            new Date().getTime()
          );
          yield API.update_user_field(user.uid, "approve", user.approve);
          const state = store.getState();
          const firestoreUser = state.userReducer.firestoreUser;
          console.log("state", firestoreUser);
          yield API.update_user_field(
            user.uid,
            "approveAdminEmail",
            firestoreUser.email
          );
          break;
        case BLOCK_USER:
          yield API.update_user_field(user.uid, "isBlocked", true);
          break;
        case UNBLOCK_USER:
          yield API.reset_user(user.uid, "isBlocked");
          break;
        case SET_TEST_ACCOUNT:
          yield API.update_user_field(user.uid, "isTestAccount", true);
          break;
        case UNSET_TEST_ACCOUNT:
          yield API.reset_user(user.uid, "isTestAccount", false);
          break;
        case UPDATE_RAKUTEN_TRACKING_ID:
          yield API.update_user_field(
            user.uid,
            "rakutenTrackingId",
            user.rakutenTrackingId
          );
          break;
        default:
          break;
      }

      for (var i = 0; i < data.length; i++) {
        if (data[i].uid === user.uid) {
          data[i] = user;
          break;
        }
      }
    } else {
      data = yield API.get_users();
    }

    const firestoreUser = data?.find((u) => user?.id === u);

    yield put({
      type: FETCH_USER_SUCCESS,
      firestoreUser,
      users: data,
    });
  } catch (error) {
    console.log("ERROR USER", error);
    yield put({ type: FETCH_USER_FAIL });
  }
}
export function* watchUsers() {
  yield takeLatest(FETCH_USER, getUsers);
}

// function* getMutes(action) {
//   try {
//     var muteIds = [];
//     const {ids, id, flag} = action;
//     if (id) {
//       muteIds = ids.slice(0);

//       if (flag) {
//         muteIds.push(id);
//       } else {
//         muteIds = muteIds.filter(muteId => muteId !== id);
//       }
//       API.mute_user(id, flag);
//     } else {
//       muteIds = yield API.get_mute_user_ids();
//     }

//     yield put({
//       type: FETCH_MUTE_IDS_SUCCESS,
//       muteIds: muteIds,
//     });
//   } catch (error) {
//     yield put({type: FETCH_MUTE_IDS_FAIL});
//   }
// }
// export function* watchMutes() {
//   yield takeLatest(FETCH_MUTE_IDS, getMutes);
// }
